import { frontendConfig } from '@kiku/config/env/frontend';
import posthog from 'posthog-js';

import type { AnalyticsContext, CommChannel, StageChangeSource } from './analytics.types.js';
import { ANALYTICS_EVENTS } from './analytics.types.js';

export { posthog, ANALYTICS_EVENTS };
export type { CommChannel, StageChangeSource };

export function initPostHog(): void {
  posthog.init(frontendConfig.VITE_PUBLIC_POSTHOG_KEY, {
    api_host: frontendConfig.VITE_PUBLIC_POSTHOG_HOST,
    person_profiles: 'identified_only',
    capture_pageview: false,
    capture_pageleave: true,
    autocapture: false,
    loaded: (ph) => {
      if (frontendConfig.MODE !== 'production') ph.opt_out_capturing();
    }
  });
}

/**
 * Set ambient context that will be automatically attached to all subsequent events.
 * Call this in layout components when org/dept/job context becomes known.
 * Mirrors the AsyncLocalStorage pattern used by the backend logger.
 */
export function registerAnalyticsContext(ctx: Partial<AnalyticsContext>): void {
  posthog.register({
    ...(ctx.tenantId !== undefined && { tenant_id: ctx.tenantId }),
    ...(ctx.orgId !== undefined && { org_id: ctx.orgId }),
    ...(ctx.deptId !== undefined && { dept_id: ctx.deptId }),
    ...(ctx.userId !== undefined && { user_id: ctx.userId }),
    ...(ctx.jobId !== undefined && { job_id: ctx.jobId }),
    ...(ctx.applicationId !== undefined && { application_id: ctx.applicationId })
  });
}

export function unregisterAnalyticsContext(keys: (keyof AnalyticsContext)[]): void {
  const keyMap: Record<keyof AnalyticsContext, string> = {
    tenantId: 'tenant_id',
    orgId: 'org_id',
    deptId: 'dept_id',
    userId: 'user_id',
    jobId: 'job_id',
    applicationId: 'application_id'
  };
  for (const key of keys) {
    posthog.unregister(keyMap[key]);
  }
}
